/* eslint-disable array-callback-return */
import { Component } from "react";
import { rightSideArrow, popCancelBttn, iIcon } from "../../assets";
import { Link } from "react-router-dom";
import trackingService from "../../services/trackingService";
import "./ContentShortcuts.css";

class MCETTemplatesDocumentsTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCSModal: false,
      showInfo: false,
      startIndex: 0,
      mcetList: [],
    };
  }
  async componentDidMount() {
    

  }
  componentWillReceiveProps() {
    if (this.props.mcetList?.length !== this.state.mcetList.length) {
      this.setState({ mcetList: this.props.mcetList })
    }
  }
  componentDidUpdate = () => {
    if (this.props.showMCECSModal !== this.state.showCSModal) {
      this.setState({ showCSModal: this.props.showMCECSModal });
    }
  };

  generateListOfDocTypes = (arrayOfDoc) => {
    if (arrayOfDoc.length > 0) {
      return arrayOfDoc.map((items, index) => {
        return (
          <li key={index} className="cs-modalListing-list-style-none"  style={{ listStyle: "none" }}>
            <Link
              to={items.docURL}
              target="_blank"
              className="cs-modalLink"
              onClick={() =>
                this.handelDocsTypesLinks("", items.docTitle)
              }
            >
              {items.docTitle}
            </Link>
          </li>
        );

      });
    }
    else{
       <li className="cs-modalListing-list-style-none"  style={{ listStyle: "none" }}>
            <Link
              className="cs-modalLink">
              Template not available.
            </Link>
          </li>
    }
  };
  handelDocsTypesLinks = (filter, title) => {
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      // "Link visited from Scientific Communication Documents tile",
      `Visited from MCET Templates for ${title}`,
      "",
      window.location.href,
      "",
      filter,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      `MCET Templates Documents-${title}`,
      ""
    );
  };
  onMouseEnterInfo = () => {
    this.setState({
      showInfo: true,
    });
  };
  onMouseLeaveInfo = () => {
    this.setState({
      showInfo: false,
    });
  };
  showDetails = () => {
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      "Expanded MCET Templates tile under content shortcuts",
      "",
      window.location.href
      //   this.state.searchKeyword,
      //   this.props.appliedFilters
    );
    this.setState({ showCSModal: !this.state.showCSModal }, () => {
      this.props.handelMCETCardDetail(this.state.showCSModal);
    });
  };
  handleCloseModal = () => {
    this.setState({ showCSModal: false }, () => {
      this.props.handelMCETCardDetail(this.state.showCSModal);
    });
  };
  render() {
    return (
      <div className="contentShortcutInnerWapper">
        <div
          className="cardContainer"
          onClick={this.showDetails}
          style={{
            borderTop: this.state.showCSModal ? "5px solid #eb1700" : "none",
          }}
        >
          <div
            className="cardInnerWapper"
            style={this.state.showCSModal ? { borderBottom: "none" } : {}}
          >
            <div
              className="card-leftPart cs-left-r1-tile-"
              style={
                this.props.customWidth >= 1000
                  ? { textAlign: "center", position: "absolute", width: "31%" }
                  : {}
              }
            >
              <small>
                <span className="cs-name-bold">MCET Templates</span> <br /> (Core Assets)
              </small>
            </div>
            <div
              className="card-iconsPart"
              style={
                this.props.customWidth >= 1000 ? { marginLeft: "auto" } : {}
              }
            >
              <img
                src={iIcon}
                alt="i-icon"
                width={18}
                height={18}
                onMouseEnter={this.onMouseEnterInfo}
                onMouseLeave={this.onMouseLeaveInfo}
                className="cs-tile-i-icon"
              />
              <div className="card-rightPart">
                <img
                  src={rightSideArrow}
                  alt="down-arrow"
                  className="cs-downArrow"
                  style={{
                    transform: this.state.showCSModal ? "rotate(270deg)" : null,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {this.state.showInfo && (
          <div className="cs-tile-wrapper">
            <div className="cs-tooltip-uparrow"></div>
            <span className="tooltiptext cs-tooltip-bottom">
              This tile provides direct link to MCET Templates.
            </span>
          </div>
        )}
        {this.state.showCSModal && (
          <div
            className="cs-modalInner cs-modalInner-left-pop-"
            style={
              this.props.customWidth >= 1000
                ? { position: "absolute", width: "100%", left: "0.1%" }
                : {}
            }
          >
            <div>
              <div class="popup-cancel-btn-wrapper">
                <img
                  src={popCancelBttn}
                  alt=""
                  onClick={this.handleCloseModal}
                />
              </div>
              <div>
                <div
                  class="modal-body"
                  style={{ width: "95%" }}
                >
                  {/* <div>{convertToHtml(privacyHtml)}</div> */}
                  <div className="cs-modalList">
                    <ul style={{ listStyle: "none" }}>
                      <li className="cs-modalListing">
                        <Link
                          className="cs-modalLink">
                          Core Asset Templates
                        </Link>
                      </li>
                      <ul className="cs-modalList-mcet-ul" style={{ listStyle: "none" }}>
                        {this.generateListOfDocTypes(this.state.mcetList)}
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MCETTemplatesDocumentsTile;
